import { combineReducers } from 'redux'
import balances from 'state/slices/user/walletBalances'
import portfolio from 'state/slices/user/portfolio'
import stakedBalances from 'state/slices/user/stakedBalances'
import rewardsBalances from 'state/slices/user/rewardsBalances'

export const user = combineReducers({ balances, portfolio, stakedBalances, rewardsBalances })
